import { useEffect, useRef } from "react"

const wait = (ms: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, ms)
  })

export const useInterval = (callback: () => void, delay: number | null): void => {
  const savedCallback = useRef<() => void>(callback)

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    function tick() {
      savedCallback.current()
    }
    if (delay !== null) {
      const id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay])
}

export const useAwaitingInterval = (asyncCallback: () => Promise<void>, ms: number): void => {
  const savedCallback = useRef(asyncCallback)
  useEffect(() => {
    savedCallback.current = asyncCallback
  }, [asyncCallback])
  useEffect(() => {
    let canceled = false
    const loop = async () => {
      while (!canceled) {
        await wait(ms)
        if (canceled) break
        await savedCallback.current()
      }
    }
    void loop()
    return () => {
      canceled = true
    }
  }, [ms])
}
